import Button from '../../../components/base/Button';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/4ab89c511e26839fe6e9f192390ed281.jfif')`
      }}
    >
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <div className="mb-8">
            <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center mx-auto mb-6 p-4">
              <img 
                src="https://static.readdy.ai/image/538ca75b02212864d9ecfdf82df77bb0/c894575bb6e66422299273d3fa52e9c0.png" 
                alt="Great Golf On The Go Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-5xl md:text-7xl font-bold mb-4">
              Great Golf On The Go
            </h1>
            <p className="text-xl md:text-2xl font-medium text-green-100 mb-8">
              Mobile Golf Simulator Experience
            </p>
          </div>
          
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Great Golf On The Go brings the thrill of golf to your location with a premium mobile simulator experience. 
            Perfect for corporate events, fundraisers, parties, and more.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-6">
            <Button 
              onClick={scrollToBooking}
              size="lg"
              className="bg-green-600 hover:bg-green-700"
            >
              <i className="ri-calendar-line mr-2"></i>
              Book Your Event
            </Button>
            <Button 
              onClick={() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-green-800"
            >
              <i className="ri-information-line mr-2"></i>
              Learn More
            </Button>
          </div>

          <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20 text-left mr-auto max-w-xl">
            <p className="text-white text-xs uppercase tracking-widest font-semibold mb-4">
              Spring League Registration is Open: Spots Limited!
            </p>
            <Link 
              to="/spring-league-registration"
              className="inline-block bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-8 py-4 rounded-full font-bold transition-colors whitespace-nowrap cursor-pointer mb-4"
            >
              <i className="ri-user-add-line mr-2"></i>
              Register for Spring League (April-May)
            </Link>
            <div className="text-white space-y-1">
              <p className="text-sm font-medium">
                Please reach out via booking request, phone, e-mail, or social media to play. Hurry, limited spots available.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
